import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import Grid from '@material-ui/core/Grid';
import { paginationLimit } from './../../helpers.js';
import { Calendar, momentLocalizer  } from 'react-big-calendar' 
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Schedule from './Schedule';
import moment from 'moment'
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
const localizer = momentLocalizer(moment)

const ScheduleCalendar = props => {
    
    const {
		clientEmail,
        fetchScheduleMessages,
        deleteScheduleMessage,
        saveScheduleMessage,
        fetchScheduleMessageDetail,
        isMobile
   } = props;

	const [date, setDate] = useState(new Date());
    const [passDate, setPassDate] = useState(null);
    const [isFetchRes, setFetchRes] = useState(false);
    const [isOpenEditMessageModal, setOpenEditMessageModal] = useState(false);
    const [message, setMessage] = useState(null);
    const [data, setData] = useState({
        message: ''
    });
    const [events, setEvents] = useState([]);
  
	useEffect(() => {
        fetchData(0)
     }, [clientEmail])
 
     const fetchData = (skip) => {
         fetchScheduleMessages({
             clientEmail,
             skip,
             limit: paginationLimit.TWENTY,
             date: date,
             isAutomation: false,
             isEvent: true
         }).then((res) => {
             const data = Object.values(res.messages);
             let eventsData = data[0]['data']
             setFetchRes(true);
             eventsData = eventsData.map((e) => {
                 return {
                    id: e._id,
                    title: e.message,
                    allDay: true,
                    start: new Date(e.startDate),
                    end: new Date(e.startDate),
                    data: e
                 }
             })
             setEvents(eventsData)
         }) 
     }

    const onEditBodyMatrixClose = () => {
        setOpenEditMessageModal(false)
    }

    const showEditActionMode = (message) => {
        setOpenEditMessageModal(true)
        setMessage(message)
    }


    const updateMessage = (message) => {
        const findIndex = events.findIndex((r) => r.id === message._id);
        if (findIndex > -1) {
            events[findIndex] = {
                id: message._id,
                title: message.message,
                allDay: true,
                start: new Date(message.startDate),
                end: new Date(message.startDate),
                data: message
            };
            setEvents([...events]);
        }
    }

    const eventStyleGetter = (event, start, end, isSelected) => {
        const { data } = event;
        var backgroundColor = !data.isSent ? '#ea5e01' : '#ff0000';
        var style = {
            backgroundColor: backgroundColor,
            borderRadius: '0px',
            opacity: 0.8,
            color: 'white',
            border: '0px',
            display: 'block'
        };
        return {
            style: style
        };
    }
    
    return (
        <Fragment>
            <div
					style={{
						marginTop: 25,
					    width: '800px'
					}}
				>
                   

                   <div style={{marginTop: '5px'}}>
                   <div style={{
                                display: 'flow-root',
                                padding: 20,
                                paddingLeft: 0,
                                width: '100%',
                                }}>
                            <div style={{
                                display: 'initial',
                                float: 'left',
                                width: '100%',
                                height: '100%'
                                
                            }}>
                                { isOpenEditMessageModal && (
                                    <Modal
                                    className="modal show"
                                    open={isOpenEditMessageModal}
                                    onClose={() => { onEditBodyMatrixClose()}}
                                    >
                                    <div className="modalBody modal-content" style={{ width: isMobile ? '80%' : 700, minHeight: 500 }}>
                                            <Fragment>
                                                <ModalHeading
                                                    text={ `Edit Message` }
                                                    closeModal={() => { onEditBodyMatrixClose()}}
                                                />
                                                <div className="modalContent">
                                                <Schedule
                                                        isEdit={true}
                                                        clientEmail = {clientEmail}
                                                        isOpenAddModal = { true }
                                                        message = {message}
                                                        parentData = { updateMessage }
                                                        hideActionModal = {() => {
                                                            setOpenEditMessageModal(false)
                                                        }}
                                                        isMobile = {isMobile}
                                                        user = { props.user}
                                                        saveScheduleMessage = { saveScheduleMessage}
                                                        fetchScheduleMessageDetail = { fetchScheduleMessageDetail }
                                                        fetchScheduleMessages = { fetchScheduleMessages }
                                                />
                                                </div>
                                            </Fragment>
                                    </div>
                                    </Modal>
                                )}
                                
                                <Calendar 
                                     events={events}
                                     startAccessor="start"
                                     endAccessor="end"
                                     defaultView="month"
                                     views = {['month']}
                                     onSelectEvent={(slotInfo) => {
                                            showEditActionMode(slotInfo.data)
                                     }}
                                     defaultDate={moment().toDate()}
                                     localizer={localizer}
                                     toolbar={true}
                                     style={{ height: "100vh" }}
                                     eventPropGetter = { eventStyleGetter }
                                            
                                 />
                            </div>
                        </div>
                       
                    </div>
                </div>
        </Fragment>
    );
};

export default ScheduleCalendar;



// WEBPACK FOOTER //
// ./src/components/assignments/ScheduleCalendar.js